module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/modules/$.library.js
// module id = 718
// module chunks = 0